/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconKeyBasic: {
  name: 'key_basic';
  data: string;
} = {
  name: 'key_basic',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M340.954 76.208v19.387c-5.136 1.234-8.3 6.398-7.066 11.534a9.563 9.563 0 0 0 9.457 7.329c5.281.01 9.571-4.262 9.581-9.544a9.564 9.564 0 0 0-7.191-9.283V88.16h4.781v-3.586h-4.781v-3.585h7.172v-4.781h-11.953zm2.017 23.906h.374a4.781 4.781 0 1 1 0 9.562 4.785 4.785 0 0 1-.374-9.562z" transform="translate(-4842.953 -1123.962) scale(14.9995)"/></svg>`,
};
